import View from '../../view.js';

class NodeFailOver extends View {
  get dom() {
    return {
      ENABLE_CHECKBOX: '#enable-failover-cluster',
      NODE_CONTAINER: '.fail-over-node',
      YES: '#failover-awner-yes',
      NO: '#failover-awner-no',
      FORM: '.fail-over-form',
      OPERATOR: '.failover-operator',
    };
  }

  get events() {
    let events = [];

    events[`change ${this.dom.ENABLE_CHECKBOX}`] = 'toogle';
    events[`click ${this.dom.YES}`] = 'useSuggested';
    events[`click ${this.dom.NO}`] = 'resetState';

    return events;
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  formClose() {
    const operator = this.$(this.dom.OPERATOR);

    operator.find('span').text('Expand');
    operator
      .find('.fa-angle-up')
      .removeClass('fa-angle-up')
      .addClass('fa-angle-down');
    operator.removeClass('expanded').addClass('closed');
    this.$(this.dom.FORM).slideUp();
  }

  formOpen() {
    const operator = this.$(this.dom.OPERATOR);

    operator.find('span').text('Collapse');
    operator
      .find('.fa-angle-down')
      .removeClass('fa-angle-down')
      .addClass('fa-angle-up');
    operator.removeClass('closed').addClass('expanded');
    this.$(this.dom.FORM)
      .removeClass('hidden')
      .css('display', 'none')
      .slideDown();
  }

  toogle() {
    const enabled = $(this.dom.ENABLE_CHECKBOX).is(':checked');

    if (enabled) {
      this.startWizard();
    } else {
      this.resetState();
    }
  }

  startWizard() {
    $(this.dom.NODE_CONTAINER).removeClass('hidden');
  }

  useSuggested() {
    $(this.dom.NODE_CONTAINER).addClass('hidden');
    $(this.dom.OPERATOR).removeClass('hidden');
    this.formOpen();
  }

  resetState(e) {
    const checkbox = $(this.dom.ENABLE_CHECKBOX);

    if (e) {
      e.preventDefault();
    }

    $(this.dom.NODE_CONTAINER).addClass('hidden');
    this.formClose();
    $(this.dom.OPERATOR).addClass('hidden');

    if (checkbox.is(':checked')) {
      checkbox.prop('checked', false).trigger('change');
      checkbox.next().removeClass('checked');
    }
  }
}

module.exports = NodeFailOver;
